@if (!message?.errorData) {
  <div class="container-fluid">
    <div class="row">
      <div class="p-0 col-1">
        <i [ngClass]="['fz-21', icon, 'noty-'+ notification.type]" aria-hidden="true"></i>
      </div>
      <div class="p-0  col-10 notification-title" [ngClass]="'noty-'+ notification.type">
        {{'general.noty_title_' + notification.type | translate }}
      </div>
      <div class="p-0 col-1">
        <a (click)="close()" class="c-white">
          <i class="ti-close c-white"></i>
        </a>
      </div>
      <div class="p-0  col-10 offset-1 notification-message">
        {{message?.title}}
      </div>
      @if (notification.type !== status.SUCCESS) {
        <div class="p-0 col-7 now-cnt notification-message-date">
          {{ notificationTime | localizedDate:'dd-MM-yyyy HH:mm:ss'}}
        </div>
      }
    </div>
  </div>
}
